import React, { useEffect, useState } from "react";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { reportsAnalyticsProductsThunk } from "../../../store/thunks/reportsAnalyticsThunk";
import { Pagination } from "../../../components/atoms/pagination";
import TableLoader from "../../../components/atoms/Loader/tableLoader";
import { AllRangePicker } from "../../../components/atoms/formFields/rangePicker/allRangePicker";
import VendorStore from "../../../components/atoms/vendorStores";

export default function AllProducts() {
  const dispatch = useDispatch();
  const { list, loading, pageInfo } = useSelector(
    (state) => state?.reportsAnalyticsProducts || {}
  );
  const { storeId } = useSelector((state) => state?.storeData || {});
  const [offset, setOffset] = useState(0);
  const [filter, setFilter] = useState({
    fromDate: "",
    toDate: "",
  });

  useEffect(() => {
    if (storeId) {
      setFilter((prev) => ({
        ...prev,
        inventoryId: storeId,
      }));
    }
  }, [storeId]);

  useEffect(() => {
    dispatch(
      reportsAnalyticsProductsThunk({
        inventoryReportPagination: {
          paginationFilter: { limit: 10, offset: offset, order: "DESC" },
          fromDate: filter?.fromDate,
          toDate: filter?.toDate,
          inventoryId: filter?.inventoryId,
        },
      })
    );
  }, [dispatch, offset, filter]);

  return (
    <>
      <div className="d-flex justify-content-between my-5">
        <VendorStore
          value={filter?.inventoryId}
          onChange={(val) => {
            if (val) {
              setFilter({
                ...filter,
                inventoryId: val.value,
              });
              setOffset(0);
            } else {
              setFilter({
                ...filter,
                inventoryId: "",
              });
              setOffset(0);
            }
          }}
        />
        <AllRangePicker
          disabledDate={(current) => moment().add(0, "days") <= current}
          onChange={(value) => {
            if (value) {
              setFilter({
                fromDate: moment(value[0]["$d"]).format("DD/MM/YYYY"),
                toDate: moment(value[1]["$d"]).format("DD/MM/YYYY"),
              });
            } else {
              setFilter({ fromDate: "", toDate: "" });
            }
            setOffset(0);
          }}
        />
      </div>

      <div className="table-responsive">
        <table className="table table-bordered m-0 border radius-remove all_domain_table table-stripd">
          <thead className="text-white bg-gray-700">
            <tr>
              <th className="width">S.No.</th>
              <th className="width">Product Type</th>
              <th className="width">Product Name</th>
              <th className="width">Product Image</th>
              <th className="width">Inventory</th>
              <th className="width">Stock</th>
              <th className="width">Sale Quantity</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan={8}>
                  <TableLoader />
                </td>
              </tr>
            ) : list?.length > 0 ? (
              list.map((item, i) => {
                const { productId, productType, variantInfo, productName } =
                  item;
                const masterVariant = variantInfo[0];
                return (
                  <React.Fragment key={productId}>
                    <tr className="greyBackground" id={`prod_${productId}`}>
                      <td>{i + 1 + offset * 10}</td>
                      <td>{productType?.en || "-"}</td>
                      <td
                        className="font-weight-bolder text-left"
                        nowrap="nowrap"
                      >
                        {variantInfo && variantInfo.length > 0 ? (
                          <span
                            className="btn btn-icon btn-light btn-xs btn-hover-primary mr-5 view-button collapsed"
                            data-target={`#product_variant_${i}`}
                            data-toggle="collapse"
                          ></span>
                        ) : (
                          ""
                        )}
                        <span>
                          {productName?.en || "-"} - {masterVariant?.variant}
                        </span>
                      </td>
                      <td>
                        <img
                          src={masterVariant?.imageUrl}
                          className="max-w-70px"
                          alt="product img"
                        />
                      </td>
                      <td>{masterVariant?.inventoryName || "-"}</td>
                      <td>{masterVariant?.stockSize || "-"}</td>
                      <td>{masterVariant?.saleQuantity || "-"}</td>
                    </tr>
                    {variantInfo?.map((variantObj, index) => (
                      <tr
                        className="collapse table-collapse-bg"
                        id={`product_variant_${i}`}
                        key={`${productId}_${index}`}
                      >
                        <td></td>
                        <td></td>
                        <td nowrap="nowrap">
                          {productName?.en || "-"} - {variantObj?.variant}
                        </td>
                        <td>
                          <img
                            src={variantObj?.imageUrl}
                            className="max-w-40px m-2"
                            alt=""
                          />
                        </td>
                        <td>{variantObj?.inventoryName || "-"}</td>
                        <td>{variantObj?.stockSize || "-"}</td>
                        <td>{variantObj?.saleQuantity || "-"}</td>
                      </tr>
                    ))}
                  </React.Fragment>
                );
              })
            ) : (
              <tr>
                <td colSpan={7}>No Data Found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="my-5">
        <Pagination pageInfo={pageInfo} setOffset={setOffset} offset={offset} />
      </div>
    </>
  );
}
